import classnames from 'classnames';
import React from 'react';

import {api} from 'app/modules/Remote';
import {ApiDefaultPaymentMethod} from 'app/modules/Remote/Organization';
import {useApiGet} from 'app/utils/hookUtils';

import cs from './ContractHistory.module.scss';

export const PaymentMethodSection: React.FunctionComponent<{
  organizationId: string;
}> = ({organizationId}) => {
  const [billingInfoMaybe] = useApiGet(
    async (organizationId) =>
      await (await api.organizations.getBillingInfo(organizationId)).get('data'),
    [organizationId]
  );

  const defaultPaymentMethod: ApiDefaultPaymentMethod | null = billingInfoMaybe.value?.toJS();

  return (
    <div className={cs.planBillingCardSection}>
      <div className={cs.sectionLabel}>Payment method</div>
      {billingInfoMaybe.error ? (
        <div className={cs.sectionSub}>Couldn't load payment method</div>
      ) : (
        <>
          <div
            className={classnames(
              cs.sectionValue,
              billingInfoMaybe.status === 'unknown' ? 'bp5-skeleton' : ''
            )}
          >
            {defaultPaymentMethod &&
            ('card' in defaultPaymentMethod || 'us_bank_account' in defaultPaymentMethod) ? (
              'card' in defaultPaymentMethod ? (
                <span style={{textTransform: 'capitalize'}}>{defaultPaymentMethod.card.brand}</span>
              ) : (
                'Bank account'
              )
            ) : (
              'No payment method specified'
            )}
          </div>
          <div
            className={classnames(
              cs.sectionSub,
              billingInfoMaybe.status === 'unknown' ? 'bp5-skeleton' : ''
            )}
          >
            {defaultPaymentMethod &&
            ('card' in defaultPaymentMethod || 'us_bank_account' in defaultPaymentMethod)
              ? 'card' in defaultPaymentMethod
                ? `Ending in ${defaultPaymentMethod.card.last4}`
                : `Ending in ${defaultPaymentMethod.us_bank_account.last4}`
              : null}
          </div>
        </>
      )}
    </div>
  );
};
